import { SupplierFullDtoIn } from '@/models/in/SupplierFullDtoIn';
import { SupplierApprovalStatus } from '@/models/common/ProjectStatus';

/**
 * The approval that matters when a coordinator picks a supplier for a request (SPR-10302).
 *
 * The office approves a supplier per project ("כל ספק מאושר רק למיזם מסויים"), so once a project is
 * chosen the supplier's link to THAT project decides. A supplier not on the project yet has no link:
 * it falls back to its own status (filing the request links it, and the server marks it pending).
 * With no project chosen it is the supplier's own status, as before.
 */
export const supplierApprovalFor = (
  supplier: SupplierFullDtoIn,
  projectId: number | null | undefined
): SupplierApprovalStatus | undefined => {
  if (projectId == null) return supplier.approvalStatus;
  const link = supplier.projectApprovals?.find((approval) => approval.projectId === projectId);
  return link?.approvalStatus ?? supplier.approvalStatus;
};

/**
 * Whether the supplier may be offered for a request on this project. A rejected supplier is not paid
 * - the server refuses it - whether the office rejected it outright or for this project only.
 * Pending IS offered: "להגיש בקשת תשלום לספק גם אם הוא לא אושר עדיין".
 */
export const isSupplierOfferable = (supplier: SupplierFullDtoIn, projectId: number | null | undefined): boolean =>
  supplier.approvalStatus !== SupplierApprovalStatus.Rejected
  && supplierApprovalFor(supplier, projectId) !== SupplierApprovalStatus.Rejected;
